<div class="container-fluid">
    <div class="row mb-2">
        <div class="col-md-12">
            <div class="row align-items-center">
                <div class="col-md-1 text-center">
                    <i class="fa-solid fa-comments fa-2xl"></i>
                </div>
                <div class="col-md-11">
                    <h5>{{cintillo}}</h5>
                </div>
            </div>
        </div>
    </div>
    <div class="row mb-3">
        <div class="col-md-12">
            <!-- mospina 10-10-16 EPT-2380 Cambio general identidad AVATAR -->
            <div class="rounded" style="background-color: var(--app-claro, #53aaed); padding: 0.5em 0;">
                <div class="row align-items-center" style="color: white; text-align: center;">
                    <div class="col-md-2"><i class="fa fa-user-pen fa-2x"></i></div>
                    <div class="col-md-8">
                        <h4 class="mb-0" style="color: white">{{tituloPantalla}}</h4>
                    </div>
                </div>
            </div>
            <div style="background-color: black; padding: 0.5em 0; color: white;">
                <div class="row align-items-center">
                    <div class="col-md-2 offset-md-8 offset-sm-0 col-sm-12" style="text-align: right">
                        <h5 class="mb-0" style="color: white; padding-right: 1em;">
                            <i class="fa-regular fa-calendar"></i> &nbsp; {{ahora | date: 'yyyy/MM/dd' }}
                        </h5>
                    </div>
                    <div class="col-md-2 col-sm-12" style="text-align: right">
                        <h5 class="mb-0" style="color: white; padding-right: 1em;">
                            <i class="fa-regular fa-clock"></i>&nbsp; {{ahora | date: 'hh:mm:ss a' }}
                        </h5>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>